import React, { useEffect, useState } from "react";

import "./stylesMarginByBetType.css";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function MarginByBetType() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [isLoading, setIsLoading] = useState(false);

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("month")];
  const [dates, setDates] = useState(thisMonthRange);

  const [allDates, setAllDates] = useState([]);
  const [parlayData, setParlayData] = useState([]);
  const [singleData, setSingleData] = useState([]);
  const [roundRobinData, setRoundRobinData] = useState([]);

  const data = {
    labels: allDates,
    datasets: [
      {
        label: "Single",
        data: singleData,
        backgroundColor: "#6177E8",
        borderRadius: 5,
      },
      {
        label: "Parlay",
        data: parlayData,
        backgroundColor: "#E74C3C",
        borderRadius: 5,
      },
      {
        label: "Round Robin",
        data: roundRobinData,
        backgroundColor: "#3498DB",
        borderRadius: 5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        beginAtZero: true,
        stacked: false,
      },
      y: {
        stacked: false,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      datalabels: {
        display: false,
        anchor: "end",
        align: "start",
        formatter: (value) => value.toLocaleString(),
        color: "black",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "index",
        intersect: false,
        backgroundColor: "#252729",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
        callbacks: {
          label: function (tooltipItem) {
            const label = tooltipItem.dataset.label || "";
            const value = tooltipItem.raw;
            return `${label}: ${value}%`;
          },
        },
      },
    },
  };

  const getMarginByBetTypeData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
    };
    
    try {
      setIsLoading(true);
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_MARGIN_BY_BET_TYPE,
        params
      );

      const data = response?.data?.data?.data;
      const parlayData = data.filter((item) => item.bet_type === "Parlay")[0]
        ?.data || [];
      const singleData = data.filter((item) => item.bet_type === "Single")[0]
        ?.data || [];
      const roundRobinData = data.filter(
        (item) => item.bet_type === "Round Robin"
      )[0]?.data || [];

      const parlayDataMargin = parlayData.map((item) => item.margin);
      const singleDataMargin = singleData.map((item) => item.margin);
      const roundRobinDataMargin = roundRobinData.map((item) => item.margin);

      const allDatesSet = new Set([
        ...parlayData.map((item) => item.date),
        ...singleData.map((item) => item.date),
        ...roundRobinData.map((item) => item.date),
      ]);

      const allDates = Array.from(allDatesSet);

      setAllDates(allDates);
      setParlayData(parlayDataMargin);
      setSingleData(singleDataMargin);
      setRoundRobinData(roundRobinDataMargin);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMarginByBetTypeData(dates, false);
  }, []);

  return (
    <div className="margin-by-bet-type-container">
      <div className="margin-by-bet-type-header">
        <h2>Margin By Bet Type</h2>
        <CustomDatePicker
          getData={getMarginByBetTypeData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>

      <div className="margin-by-bet-type-chart">
        {isLoading ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="bet-types">
              <div className="bet-type single">
                <div className="bet-type-icon"></div>
                <span>Single</span>
              </div>
              <div className="bet-type parlay">
                <div className="bet-type-icon"></div>
                <span>Parlay</span>
              </div>
              <div className="bet-type round-robin">
                <div className="bet-type-icon"></div>
                <span>Round Robin</span>
              </div>
            </div>
            <div className="margin-by-bet-type-chart-container">
              <Bar data={data} options={options} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MarginByBetType;
